<template>
  <div :class="$style.page">
    <div :class="$style.title">Whois 查询</div>
    <div :class="$style.searchBox">
      <el-input
        v-model.trim="search"
        clearable
        placeholder="请输入域名信息"
        maxlength="30"
        @on-keyup="change"
        @on-enter="searchEvnet"
      />

      <div :class="$style.searchBtn" @click="searchEvnet">查询</div>
    </div>
    <div :class="$style.whoisLeft">
      <div :class="$style.formTit">什么是Whois查询？</div>
      <div :class="$style.formStit">
        您可以用Whois来查看域名的当前信息状态，包括域名是否已被注册、注册日期、过期日期、域名状态、DNS解析服务器等。
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return { search: "" };
  },
  methods: {
    change() {
      this.search = this.search.replace(/\s+/g, "");
    },
    // 搜索
    searchEvnet() {
      if (!this.search) {
        this.$Message.warning("请输入查询的域名信息！");
        return false;
      }
      const domain =
        // eslint-disable-next-line max-len
        /[^.]+\.(top|com.cn|com|cn|xyz|club|中国|网址|work|vip|beer|在线|net.cn|tv|org.cn|org|name|cc|中文网|info|pro|red|网店|net|yoga|fashion|luxe|love|kim|blue|pet|pink|移动|ski|ltd|chat|group|pub|run|city|live|ink|wiki|design|email|company|plus|video|center|cool|fund|gold|guru|life|show|team|today|world|zone|social|网站|bio|black|green|lotto|organic|poker|promo|vote|archi|voto|online|site|store|tech|fun|space|host|press|wang|商店|企业|娱乐|游戏|fit|icu|art|website|asia|我爱你|集团|biz|games|tax|studio|shopping|media|cash|fyi|vin|sale|mba|band|cab|fan|news|cafe|technology|market|fans|ren|cloud|co|shop|law|link|ac.cn|bj.cn|tj.cn|sh.cn|cq.cn|he.cn|ha.cn|sx.cn|nm.cn|ln.cn|jl.cn|hl.cn|js.cn|zj.cn|ah.cn|fj.cn|jx.cn|sd.cn|hb.cn|hn.cn|gd.cn|gx.cn|hi.cn|sc.cn|gz.cn|yn.cn|xz.cn|sn.cn|gs.cn|qh.cn|nx.cn|xj.cn|tw.cn|hk.cn|mo.cn)/;
      // 获取最后一个带点的数据
      const temp = this.search.match(domain);
      if (temp && temp.length > 0) {
        this.search = temp[0];
      } else {
        this.$Message.warning("请输入正确域名信息！");
        return false;
      }
      this.$router.push({ path: "/whois", query: { key: this.search } });
    },
  },
};
</script>




<style lang="scss" module scoped>
.page {
  width: rem(1200);
  margin: rem(80) auto rem(100);
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
  }
  .searchBox {
    display: flex;
    margin-top: 40px;
    .searchBtn {
      width: 160px;
      height: 38px;
      background: #ff5c35;
      color: #fff;
      line-height: 38px;
      text-align: center;
      cursor: pointer;
    }
    ::v-deep .el-input {
      width: rem(430);
      .el-input__inner &:hover {
        border: 1px solid #dcdfe6;
      }
    }
  }
  .whoisLeft {
    margin-top: 24px;
    padding: 20px 38px;
    background: #fff;
    color: #333;
    .formTit {
      font-size: 30px;
    }
    .formStit {
      font-size: 18px;
      margin-top: 10px;
      line-height: 30px;
    }
  }
}
</style>
